import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class TransactionStore extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list: [],
      list_all: {
        list: [],
        total: 0,
        error: null,
        loading: true
      },

      latest: {
        list: [],
        error: null,
        loading: true
      },

      detail: {
        data: null,
        error: null,
        loading: true
      }
    };
    super('transactions', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, () => {
      this.state.detail.loading = true;
      this.state.detail.error = null;
      this.state.detail.data = null;
    });
    this.on(constants.EVENTS.TRANSACTIONS.DETAIL.REFRESHED, (data) => {
      this.state.detail.data = data;
      this.state.detail.loading = false;
      this.state.detail.error = null;
    });
    this.on(constants.EVENTS.TRANSACTIONS.DETAIL.REFRESH_ERROR, (error) => {
      this.state.detail.loading = false;
      this.state.detail.error =
        error?.message || error || "Une Erreur inconnue s'est produite";
    });

    this.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
      this.state.list_all.list = [];
      this.state.list_all.total = 0;
    });
    this.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = Array.isArray(data) ? data : [];
      this.state.list_all.total = 100;
      this.state.list_all.loading = false;
      this.state.list_all.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });
    this.on(constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error =
        error?.message || error || "Une Erreur inconnue s'est produite";
    });

    this.on(constants.EVENTS.TRANSACTIONS.LATEST.REFRESHING, () => {
      this.state.latest.loading = true;
      this.state.latest.error = null;
    });
    this.on(constants.EVENTS.TRANSACTIONS.LATEST.REFRESHED, (data) => {
      this.state.latest.list = Array.isArray(data) ? data : [];
      this.state.latest.loading = false;
      this.state.latest.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });
    this.on(constants.EVENTS.TRANSACTIONS.LATEST.REFRESH_ERROR, (error) => {
      this.state.latest.loading = false;
      this.state.latest.error =
        error?.message || error || "Une Erreur inconnue s'est produite";
    });
  }
}

export default TransactionStore;
